var render, staticRenderFns
import script from "./ByPersonTrendChart.vue?vue&type=script&lang=js&"
export * from "./ByPersonTrendChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186e57ea')) {
      api.createRecord('186e57ea', component.options)
    } else {
      api.reload('186e57ea', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/trending-charts/ByPersonTrendChart.vue"
export default component.exports